module.exports = __webpack_public_path__ + "static/media/logo.9843d90d.png";